export default "__VITE_ASSET__BP4HONcb__"